import React from 'react'
import ProductsLatest from './ProductsLatest'
import urls from '@/utils/urls/urls'
import cl from '@/utils/console/cl'

const ProductsLatestContainer = async () => {
    let products = [];

    try {
        const res = await fetch(urls?.product, {
            cache: "no-cache"
        })
        
        if (res.ok) {
            const contentType = res.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                try {
                    const data = await res.json()
                    products = Array.isArray(data?.data) ? data?.data : [];
                } catch (parseError) {
                    console.error('Error parsing products JSON:', parseError);
                    products = [];
                }
            }
        }
    } catch (error) {
        console.error('Error fetching products:', error);
        products = [];
    }
    // cl("Products", products);

    return (
        <ProductsLatest products={products} />
    )
}

export default ProductsLatestContainer
